<template>
  <v-container>
    <div v-if="alerta">
      <alert-empty></alert-empty>
    </div>
    <v-layout>
      <v-flex>
        <v-toolbar color="white" dark flat dense cad>
          <v-toolbar-title class="indigo--text"
            >Gestion de documentos contrato</v-toolbar-title
          >
          <v-btn
            color="primary"
            @click="crearTitulo()"
            v-if="
              tipeView != 'oculto' &&
              usuarioLoggedTipe != 'PROVEEDOR' &&
              getCodigoPerfil() != 'LEC' &&
              !isContratoCerrado()
            "
          >
            Agregar sección</v-btn
          >
        </v-toolbar>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <grid-administrativo :key="adminGrid"></grid-administrativo>
      </v-flex>
    </v-layout>
    <!-- Dialog titulo-->
    <v-form ref="form" lazy-validation>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-flex xs10 class="mx-4">
            <v-card-title class="headline" style="font-weight: bold"
              >Crear sección</v-card-title
            >
            <v-text-field
              v-model="nombre"
              :error-messages="nombreErrors"
              label="Nombre"
              counter="100"
              maxlength="100"
              :box="tipeView == 'consulta'"
              :readonly="tipeView == 'consulta'"
              @input="$v.nombre.$touch()"
              @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"
            ></v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="indigo darken-1" flat="flat" @click="cerrarDialog"
                >Cancelar</v-btn
              >
              <v-btn color="indigo darken-1" flat="flat" @click="saveTitulo()"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import GridAdministrativo from "@/modules/adminDocs/views/GridAdministracion.vue";
import axios from "axios";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import Loading from "@/views/ui/Loading.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import jwtDecode from "jwt-decode"; // Importación añadida

export default {
  name: "administracion-sub-tab",
  components: {
    Loading,
    GridAdministrativo,
    AlertEmpty,
  },
  mixins: [validationMixin],
  validations: {
    nombre: { required },
    tituloValue: { required },
  },
  props: {
    proveedor: {},
    show: Boolean,
    tipeView: "",
  },
  data() {
    return {
      contratoId: "",
      allowSpaces: false,
      valid: false,
      tituloValue: null,
      tituloSelect: [],
      filter: false,
      adminGrid: 0,
      usuarioLoggedTipe: "",
      tipeArchive: "",
      alerta: false,
      descripcion: "",
      //modal crear/editar titulo
      dialog: false,
      loading: false,
      idTitulo: -1,
      nombre: "",
    };
  },

  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    tituloErrors() {
      const errors = [];
      if (!this.$v.tituloValue.$dirty) return errors;
      !this.$v.tituloValue.required &&
        errors.push("Debe seleccionar el título del documento.");
      return errors;
    },
  },
  created() {
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.contratoId = this.$store.getters.contratoStored;
    this.tipeArchive = ".pdf,.doc,.jpg,.png";
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
    }
  },

  methods: {
    submit() {
      this.$v.$touch();
    },
    reloadAdmin() {
      this.procesoValue = "";
      this.adminGrid += 1;
    },
    cerrarDialog() {
      this.dialog = false;
      this.nombre = "";
    },
    saveTitulo() {
      this.dialog = false;
      if (
        this.nombre == undefined ||
        this.nombre == null ||
        this.nombre == ""
      ) {
        window.getApp.$emit("DATOS_INCOMPLETOS");
        return;
      }
      this.loading = true;
      this.body = {
        id: this.idTitulo,
        idContrato: this.$store.getters.contratoStored,
        nombre: this.nombre,
      };

      axios
        .post("/administracion/tituloSave", this.body)
        .then((response) => {
          window.getApp.$emit("APP_SAVE");
          this.nombre = "";
          this.loading = false;
          this.reloadAdmin();
        })
        .catch((error) => {
          console.log("error:" + JSON.stringify(error, null, 2));
          if (error) {
            console.log("falla tituloSave:" + error.response);
          } else {
            console.log("error tituloSave");
          }
          window.getApp.$emit("ERROR_EXCEPTION_BACK");
          this.loading = false;
        });
    },
    crearTitulo() {
      this.idTitulo = -1;
      this.nombre = "";
      this.dialog = true;
    },
    editarTitulo(id, nombre) {
      this.idTitulo = id;
      this.nombre = nombre;
      this.dialog = true;
    },
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVODED USER:", user);
      return user.perfil.codigo;
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.idContrato === this.contratoId) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
  },
};
</script>